import BaseApi from './baseApi';
import IRPTRepportsQueries from '../models/IRPTRepportsQueries';
import IAuthentication from '../models/IAuthentication';
export default class RPTRepportsQueriesApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Reports");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetRPTRepportsQueries() : Promise<IRPTRepportsQueries[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var repportsQueries: IRPTRepportsQueries[] = [];
            repportsQueries = response.data as IRPTRepportsQueries[];
            return repportsQueries;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveRPTRepportsQueries(repportQuery: IRPTRepportsQueries) : Promise<string> {
        const json = this.getJsonSave(repportQuery);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateRPTRepportsQueries(repportQuery: IRPTRepportsQueries) : Promise<boolean> {
        const json = this.getJsonUpdate(repportQuery);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteRPTRepportsQueries(repportsQueriesId: string) : Promise<boolean> {
        const json = this.getJsonDelete(repportsQueriesId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(idRepportsQuery: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "RPT_RepportsQueries",
            "conditions": [{
                "Item1": "RPT_RepportsQueries",
                "Item2": "id",
                "Item3": "=",
                "Item4": idRepportsQuery
            }]
        };
        return json;
    }

    private getJsonSave(repportQuery: IRPTRepportsQueries) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "id_RPT_Repports",
                "Item2": repportQuery.idRPTRepports
            }, {
                "Item1": "id_RPT_Queries",
                "Item2": repportQuery.idRPTQueries
            }, {
                "Item1": "execOrder",
                "Item2": repportQuery.execOrder
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "RPT_RepportsQueries"
        };
        return json;
    }

    private getJsonUpdate(repportQuery: IRPTRepportsQueries) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "id_RPT_Repports",
                "Item2": repportQuery.idRPTRepports
            }, {
                "Item1": "id_RPT_Queries",
                "Item2": repportQuery.idRPTQueries
            }, {
                "Item1": "execOrder",
                "Item2": repportQuery.execOrder
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "RPT_RepportsQueries",
            "keyvalue": repportQuery.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "RPT_RepportsQueries",
                "Item2": "id"
            }, {
                "Item1": "RPT_RepportsQueries",
                "Item2": "id_RPT_Repports"
            }, {
                "Item1": "RPT_Repports",
                "Item2": "repportName"
            }, {
                "Item1": "RPT_RepportsQueries",
                "Item2": "id_RPT_Queries"
            }, {
                "Item1": "RPT_Queries",
                "Item2": "queryName"
            }, {
                "Item1": "RPT_RepportsQueries",
                "Item2": "execOrder"
            }],
            "tables": [{
                "Item1": "RPT_RepportsQueries"
            }, {
                "Item1": "RPT_Repports"
            }, {
                "Item1": "RPT_Queries"
            }],
            "joins": [{
                "Item1": "RPT_RepportsQueries",
                "Item2": "id_RPT_Repports",
                "Item3": "RPT_Repports",
                "Item4": "id"
            }, {
                "Item1": "RPT_RepportsQueries",
                "Item2": "id_RPT_Queries",
                "Item3": "RPT_Queries",
                "Item4": "id"
            }],
            "conditions": [{
                "Item1": "RPT_RepportsQueries",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }],
            "orderBy": [{
                "Item1": "RPT_Repports.repportName"
            }]
        };
        return json;
    }
}
